import { render, staticRenderFns } from "./AccountAccessAddRule.vue?vue&type=template&id=14dc6614&scoped=true"
import script from "./AccountAccessAddRule.vue?vue&type=script&lang=ts"
export * from "./AccountAccessAddRule.vue?vue&type=script&lang=ts"
import style0 from "./AccountAccessAddRule.vue?vue&type=style&index=0&id=14dc6614&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14dc6614",
  null
  
)

export default component.exports